<template>
    <BigCard title="Moyens humains">
        <template slot="icon">
            <svg
                class="p-2"
                width="40"
                height="40"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.38933 10.189C10.0163 9.52656 10.4354 8.69495 10.5948 7.79695C10.7542 6.89894 10.6471 5.9739 10.2865 5.13615C9.92589 4.29841 9.32773 3.58469 8.56592 3.0832C7.80411 2.58172 6.91205 2.31447 6 2.31447C5.08795 2.31447 4.19589 2.58172 3.43408 3.0832C2.67227 3.58469 2.07411 4.29841 1.71353 5.13615C1.35295 5.9739 1.24576 6.89894 1.4052 7.79695C1.56464 8.69495 1.98373 9.52656 2.61067 10.189C2.97045 9.61486 3.47024 9.14163 4.06311 8.8137C4.65599 8.48578 5.32248 8.31393 6 8.3143C6.67752 8.31393 7.34402 8.48578 7.93689 8.8137C8.52976 9.14163 9.02956 9.61486 9.38933 10.189ZM3.59 11.171L6 13.5803L8.41 11.171C8.19388 10.7147 7.85266 10.3291 7.42603 10.0591C6.9994 9.78912 6.50489 9.64579 6 9.64579C5.49512 9.64579 5.0006 9.78912 4.57397 10.0591C4.14734 10.3291 3.80612 10.7147 3.59 11.171ZM6 15.4663L1.75734 11.2236C0.918228 10.3845 0.346791 9.31542 0.115286 8.15153C-0.11622 6.98765 0.00260456 5.78125 0.456732 4.6849C0.91086 3.58855 1.6799 2.65148 2.66659 1.9922C3.65328 1.33291 4.81332 0.981018 6 0.981018C7.18669 0.981018 8.34672 1.33291 9.33342 1.9922C10.3201 2.65148 11.0891 3.58855 11.5433 4.6849C11.9974 5.78125 12.1162 6.98765 11.8847 8.15153C11.6532 9.31542 11.0818 10.3845 10.2427 11.2236L6 15.4663ZM6 6.3143C6.17681 6.3143 6.34638 6.24406 6.47141 6.11904C6.59643 5.99401 6.66667 5.82444 6.66667 5.64763C6.66667 5.47082 6.59643 5.30125 6.47141 5.17623C6.34638 5.0512 6.17681 4.98097 6 4.98097C5.82319 4.98097 5.65362 5.0512 5.5286 5.17623C5.40357 5.30125 5.33333 5.47082 5.33333 5.64763C5.33333 5.82444 5.40357 5.99401 5.5286 6.11904C5.65362 6.24406 5.82319 6.3143 6 6.3143ZM6 7.64763C5.46957 7.64763 4.96086 7.43692 4.58579 7.06185C4.21072 6.68677 4 6.17806 4 5.64763C4 5.1172 4.21072 4.60849 4.58579 4.23342C4.96086 3.85835 5.46957 3.64763 6 3.64763C6.53043 3.64763 7.03914 3.85835 7.41422 4.23342C7.78929 4.60849 8 5.1172 8 5.64763C8 6.17806 7.78929 6.68677 7.41422 7.06185C7.03914 7.43692 6.53043 7.64763 6 7.64763Z"
                    fill="white"
                />
            </svg>
        </template>
        <template>
            <div class="flex justify-center items-center min-h-7 gap-7 h-12">
                <span
                    ><svg
                        width="36"
                        height="100%"
                        viewBox="0 0 36 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M35.5706 46.8589H31.1353V42.4309C31.1353 40.6693 30.4344 38.9799 29.1867 37.7342C27.939 36.4886 26.2468 35.7888 24.4824 35.7888H11.1765C9.41202 35.7888 7.71982 36.4886 6.47215 37.7342C5.22448 38.9799 4.52355 40.6693 4.52355 42.4309V46.8589H0.0882568V42.4309C0.0882568 39.4949 1.25648 36.6792 3.33593 34.6032C5.41537 32.5271 8.23571 31.3608 11.1765 31.3608H24.4824C27.4232 31.3608 30.2435 32.5271 32.3229 34.6032C34.4024 36.6792 35.5706 39.4949 35.5706 42.4309V46.8589ZM17.8294 26.9328C16.0821 26.9328 14.3518 26.5892 12.7375 25.9216C11.1231 25.254 9.65632 24.2755 8.42075 23.042C7.18519 21.8085 6.20508 20.3441 5.5364 18.7324C4.86772 17.1207 4.52355 15.3933 4.52355 13.6488C4.52355 11.9043 4.86772 10.1769 5.5364 8.5652C6.20508 6.95351 7.18519 5.48909 8.42075 4.25555C9.65632 3.02201 11.1231 2.04352 12.7375 1.37593C14.3518 0.708348 16.0821 0.364746 17.8294 0.364746C21.3584 0.364746 24.7428 1.76431 27.2381 4.25555C29.7335 6.74679 31.1353 10.1256 31.1353 13.6488C31.1353 17.1719 29.7335 20.5508 27.2381 23.042C24.7428 25.5332 21.3584 26.9328 17.8294 26.9328ZM17.8294 22.5048C20.1821 22.5048 22.4383 21.5718 24.1019 19.9109C25.7654 18.2501 26.7 15.9975 26.7 13.6488C26.7 11.3 25.7654 9.04745 24.1019 7.38663C22.4383 5.7258 20.1821 4.79276 17.8294 4.79276C15.4768 4.79276 13.2205 5.7258 11.557 7.38663C9.89342 9.04745 8.95885 11.3 8.95885 13.6488C8.95885 15.9975 9.89342 18.2501 11.557 19.9109C13.2205 21.5718 15.4768 22.5048 17.8294 22.5048Z"
                            fill="#2FA97E"
                        /></svg
                ></span>
                <div class="flex">
                    <span
                        class="h-9 w-9 rounded-full bg-green-900 absolute opacity-25"
                    ></span>
                    <span
                        class="text-6xl font-lato font-semibold text-green-900 z-10"
                        >{{ nbMoyensHumain || 0 }}</span
                    >
                </div>
            </div>
        </template>
    </BigCard>
</template>

<script>
import BigCard from "../cardWithIcon.vue";

export default {
    props: {
        nbMoyensHumain: {
            type: Number,
            required: true
        }
    },
    components: {
        BigCard
    }
};
</script>

<style></style>
